// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_ListaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /subaccounts/franchises/lista
 *
 * Optional franchise filter for the subaccounts listing.
 */
import { registerContract } from './validate'

export interface SubaccountsFranchises_ListaInput {
franchise_id?: number
}

registerContract('SubaccountsFranchises_ListaInput', {
  franchise_id: { type: 'number',  required: false },
})
